export const TaskStatus = {
  IN_PROGRESS: "edc3f774-7005-11ec-97b9-98fa9bde2f84",
  APPROVED: "edc3f786-7005-11ec-97b9-98fa9bde2f84",
  COMPLETED: "edc3f790-7005-11ec-97b9-98fa9bde2f84"
};

export const normalizeDate = date => {
  const newDate = new Date(date);

  return new Date(newDate.getTime() + Math.abs(newDate.getTimezoneOffset() * 60000));
};

export const LRD_ROLE = {
  "15edb311-3f26-45bc-8826-af27c0cb12a5": "Admin",
  "1dea83d8-1049-4be4-8afc-e9a6db8bdba0": "User"
};

export const LrdRoleType = {
  ADMIN: "15edb311-3f26-45bc-8826-af27c0cb12a5",
  USER: "1dea83d8-1049-4be4-8afc-e9a6db8bdba0"
};

export const LrdCheckType = {
  APPROVER: "Approver",
  PRIVILEGED: "Privileged"
};

export const LrdReportFrequency = {
  MONTHLY: "bbd95d5d-4688-11e9-82f6-0242ac120002",
  QUARTERLY: "d019a5e2-4688-11e9-82f6-0242ac120002",
  SEMI_ANNUALLY: "d41fb593-4688-11e9-82f6-0242ac120002",
  ANNUALLY: "d749ecb6-4688-11e9-82f6-0242ac120002",
  BI_MONTHLY: "bf12a607-4688-11e9-82f6-0242ac120002"
};

export const ReportFrequencyCheckboxes = [
  {
    name: "Monthly",
    value: LrdReportFrequency.MONTHLY
  },
  {
    name: "Bi-Monthly",
    value: LrdReportFrequency.BI_MONTHLY
  },
  {
    name: "Quarterly",
    value: LrdReportFrequency.QUARTERLY
  },
  {
    name: "Semi-Annually",
    value: LrdReportFrequency.SEMI_ANNUALLY
  },
  {
    name: "Annually",
    value: LrdReportFrequency.ANNUALLY
  }
];

export const ReportEntityCheckboxes = [
  {
    name: "Borrower",
    value: "borrower"
  },
  {
    name: "Guarantor",
    value: "guarantor"
  },
  {
    name: "Cash Management",
    value: "cashManagement"
  }
];

export const ReportStatusCheckboxes = [
  {
    name: "Not Started",
    value: "notStarted"
  },
  {
    name: "In Progress",
    value: "inProgress"
  },
  {
    name: "Ready For Approval",
    value: "readyForApproval"
  },
  {
    name: "Ready For Submission",
    value: "readyForSubmission"
  },
  {
    name: "Overdue",
    value: "overdue"
  }
];

export const LrdIconValues = {
  OVERDUE: {
    LABEL: "OVERDUE",
    ICON_NAME: "error",
    COLOR: "#C40A0A"
  },
  READY_FOR_SUBMISSION: {
    LABEL: "READY FOR SUBMISSION",
    ICON_NAME: "mark_email_read",
    COLOR: "#005AA9"
  },
  READY_FOR_APPROVAL: {
    LABEL: "READY FOR APPROVAL",
    ICON_NAME: "check_circle_outline",
    COLOR: "#50C40A"
  },
  NOT_STARTED: {
    LABEL: "NOT STARTED",
    ICON_NAME: "highlight_off",
    COLOR: "#5F6368"
  },
  IN_PROGRESS: {
    LABEL: "IN PROGRESS",
    COLOR: "#5F6368"
  }
};

export const defaultFilterState = {
  reportAssigneeId: -1,
  taskAssigneeId: -1,
  frequency: {
    [LrdReportFrequency.MONTHLY]: true,
    [LrdReportFrequency.BI_MONTHLY]: true,
    [LrdReportFrequency.QUARTERLY]: true,
    [LrdReportFrequency.SEMI_ANNUALLY]: true,
    [LrdReportFrequency.ANNUALLY]: true
  },
  entity: {
    borrower: true,
    guarantor: true,
    cashManagement: true
  },
  status: {
    notStarted: true,
    inProgress: true,
    readyForApproval: true,
    readyForSubmission: true,
    overdue: true
  }
};

export const BackButtonText = {
  LENDER_REPORTS: {
    FROM: "lender-reports-page",
    TEXT: "Back to Lender Compliance Reports"
  },
  DASHBOARD: {
    FROM: "lender-reports-dashboard",
    TEXT: "Back to Dashboard"
  },
  SUBMITTED: {
    FROM: "lender-reports-submitted",
    TEXT: "Back to Submitted Reports"
  }
};
